import { CartoonTextFilter } from "../assets/filters/CartoonTextFilter";
import { ViewportInstance } from "./ViewportInstance";
import {  Container, Graphics } from "pixi.js";
import { app, fixedWidth, isTouchDevice } from "../app";

export const graphicsContainer = new Container;

export class MenuGraphics extends ViewportInstance {

    constructor(destContainer: Container){
        super(destContainer);
        this.staticBounds = false;
        this.perX = 0;
        this.perY = 0;
        this.destX =0;
        this.destY = 0
        this.width = 0;
        this.attachment = graphicsContainer

        this.addChild(graphicsContainer)

        super.init();
        app.ticker.addOnce(() => {
            this.resize();
            this.updateLighting();
            
        });
        

        // let delay = 2044
        // const tick = () => {
        //     this.resize()
        //     if (--delay <= 0) app.ticker.remove(tick) 
        // }
        // app.ticker.add(tick)
    }

    updateSettings() {
        super.updateSettings();
        //disable drop shadows for menu
        if (this.customFilters && this.customFilters.length !== 0) {
            for (const filter of this.customFilters) {
                if (filter instanceof CartoonTextFilter) {
                    filter.dropShadows = 0
                } 
            }
        }

    }

}

